import { useCallback, useContext } from 'react';
import { imageViewerContext } from '../ImageViewerContext';
import { Button, Grid } from '@mui/material';
import { COLORS } from 'theme/MainTheme';
import { makeStyles } from '@mui/styles';
import { FormattedMessage } from 'react-intl';
import {Close} from 'components/icons';

const useStyles = makeStyles(() => ({
  button: {
    right: '2%',
    position: 'absolute',
    top: '5%',
    zIndex: 1000,
  },
  label: {
    color: COLORS.WHITE,
    textTransform: 'none',
  },
}), { name: 'CloseButton' });

const CloseButton = (): JSX.Element => {
  const { handleCurrentViewedImage } = useContext(imageViewerContext);
  const classes = useStyles();

  const handleClose = useCallback(
    () => handleCurrentViewedImage(undefined),
  [handleCurrentViewedImage]);

  return (
    <Button
      className={classes.button}
      data-testid="close-button"
      onClick={handleClose}
    >
      <Grid container>
        <Grid item xs={12}>
          <Close fontSize='xlarge' color='inherit' htmlColor='white' />
        </Grid>
        <Grid className={classes.label} item xs={12}>
          <FormattedMessage id="button.close" />
        </Grid>
      </Grid>
    </Button>
  );
};

export default CloseButton;